import React, {Component} from 'react';
import {getIndexProtectorLabel} from "../../shared/common";
import NumberFormat from 'react-number-format';
import {connect} from 'react-redux';
import * as actionTypes from '../../store/actions';
import classes from './IA.css';
import IAIndex from "../IAIndex/IAIndex";

export class IA extends Component {

    render() {

        let percentageClasses = [classes.IndexAchieverPercentage];

        if (this.props.percentageAllocationInvalid) {
            percentageClasses.push(classes.invalid);
        }

        let indexInvalidMessage = null;

        if (this.props.indexInvalid) {
            indexInvalidMessage = (
                <div className={classes.validationMessage}>{getIndexProtectorLabel(this.props.indexProtector)} strategy selections must sum to 100%</div>);
        }

        return (
            <div className={classes.IndexAchiever}>
                <div className={percentageClasses.join(' ')}>
                    <label>Percentage of Portfolio Allocated to the {getIndexProtectorLabel(this.props.indexProtector)}</label>
                    <div className={classes.percentageInputContainer}>
                        <span className={classes.instructionMsg}>Enter the percentage of the portfolio that will be allocated to the {getIndexProtectorLabel(this.props.indexProtector)} fee-based fixed-indexed annuity, then enter the strategy allocations.</span>
                        <NumberFormat
                            onValueChange={(values) => this.props.updateAllocationPercentage(values.formattedValue)}
                            onClick={() => this.props.updateAllocationPercentage("")}
                            onBlur={() => this.props.updateAllocationPercentage("BLUR")}
                            value={this.props.percentageAllocation}
                            displayType={'input'}
                            suffix={'%'}
                        />
                    </div>
                </div>
                {indexInvalidMessage}
                <div className={classes.indexLabel}>{getIndexProtectorLabel(this.props.indexProtector)} Strategy Allocations: You can allocate money to one or more indexed strategies in the fields below.*  Money allocated to an indexed strategy earns interest based, in part, on the positive performance of a market index or ETF.</div>
                <IAIndex/>
            </div>
        );

    }
}

const mapStateToProps = (state) => {
    return {
        percentageAllocation: state.planInfo.IndexAchiever.percentageAllocation.value,
        percentageAllocationInvalid: state.planInfo.IndexAchiever.percentageAllocation.invalid,
        indexInvalid: state.planInfo.IndexAchiever.indexAllocation.invalid,
        indexProtector: state.globalState.indexProtector
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateAllocationPercentage: (value) => dispatch({
            type: actionTypes.INDEXARCHIEVERPERCENTAGE_UPDATE,
            value: value
        })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(IA);


// WEBPACK FOOTER //
// ./src/containers/IA/IA.js